/*! a&k Briefkasten — Storefront-Erweiterungen (Eigenentwicklung)
 *  #5 Made-in-Germany-Hinweis (nur bei Briefkästen)
 *  #6 kleinere Bilder in der Suchvorschau
 *  #7 Produktsuche nach SKU / Artikelnummer im Shop-Frontend
 *  #8 mehr Metadaten auf der Produktseite (Artikelnummer, SKU)
 *
 *  Einbau (nach Reconnect): {% render 'ak-storefront' %} vor </body> in layout/theme.liquid.
 *  Hinweis: Selektoren für #6/#8 ggf. an Horizons echtes Markup feinjustieren.
 */
(function () {
  'use strict';
  var CFG = window.AK_STOREFRONT_CONFIG || {};
  var MAP = window.AK_SKU_MAP || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ready(fn) { if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }
  function norm(s) { return String(s == null ? '' : s).trim().toUpperCase(); }
  function handleFor(q) { var k = norm(q); return Object.prototype.hasOwnProperty.call(MAP, k) ? MAP[k] : null; }
  function productUrl(handle) { return ROOT.replace(/\/$/, '') + '/products/' + handle; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---- #6 kleinere Suchvorschau-Bilder ----
  function injectSearchCss() {
    var px = CFG.searchThumbMaxPx || 48;
    var css =
      'predictive-search img, .predictive-search img, [class*="predictive"] [class*="result"] img,' +
      '.search-modal img, [id*="predictive-search"] img, [id*="PredictiveSearch"] img,' +
      'dialog[open] form[action*="/search"] img {' +
      'max-width:' + px + 'px !important;max-height:' + px + 'px !important;height:auto !important;width:auto !important;object-fit:contain !important;}';
    var s = document.createElement('style');
    s.setAttribute('data-ak', 'search-thumbs');
    s.textContent = css;
    document.head.appendChild(s);
  }

  // ---- #7 SKU-/Artikelnummer-Suche ----
  function wireSearch() {
    // a) Suchformular-Submit: exakter SKU/Artikelnummer-Treffer -> direkt zum Produkt
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || typeof form.matches !== 'function' || !form.matches('form[action*="/search"]')) return;
      var input = form.querySelector('input[name="q"], input[type="search"]');
      if (!input) return;
      var h = handleFor(input.value);
      if (h) { e.preventDefault(); window.location.assign(productUrl(h)); }
    }, true);

    // b) Bereits auf der Suchergebnisseite mit SKU gelandet -> umleiten
    if (/\/search/.test(window.location.pathname) && /[?&]q=/.test(window.location.search)) {
      try {
        var q = new URLSearchParams(window.location.search).get('q');
        var h = handleFor(q);
        if (h) { window.location.replace(productUrl(h)); }
      } catch (err) {}
    }
  }

  // ---- #5 Made-in-Germany + #8 Metadaten auf der Produktseite ----
  function productEnhancements() {
    if (!CFG.isProduct) return;
    // #5: vorhandenes Made-in-Germany-Banner (im Template) nur bei Briefkaesten zeigen
    if (!CFG.isBriefkasten) {
      var hideCss = document.createElement('style');
      hideCss.setAttribute('data-ak', 'mig-hide');
      hideCss.textContent = '.made-in-germany-banner{display:none !important;}';
      document.head.appendChild(hideCss);
    }

    // #8: Artikelnummer (= SKU) + Lieferzeit zuverlaessig anzeigen
    var art = CFG.artikelnummer || CFG.sku || '';
    var lz = CFG.lieferzeit || '';
    if ((art || lz) && !document.querySelector('[data-ak="meta"]')) {
      var L = CFG.labels || {};
      var rows = [];
      if (art) rows.push('<span><strong>' + esc(L.artikelnummer || 'Artikelnummer') + ':</strong> ' + esc(art) + '</span>');
      if (lz) rows.push('<span><strong>' + esc(L.lieferzeit || 'Lieferzeit') + ':</strong> ' + esc(lz) + '</span>');
      var meta = document.createElement('div');
      meta.setAttribute('data-ak', 'meta');
      meta.style.cssText = 'display:flex;flex-direction:column;gap:2px;margin:8px 0;font:14px/1.5 system-ui,sans-serif;color:var(--color-foreground,#333);';
      meta.innerHTML = rows.join('');
      var anchor = document.querySelector('.made-in-germany-banner') || document.querySelector('product-price, .price') || document.querySelector('main h1, h1');
      if (anchor) anchor.insertAdjacentElement('afterend', meta); else document.body.appendChild(meta);
    }
  }

  ready(function () { injectSearchCss(); wireSearch(); productEnhancements(); });
})();
